import styles from "./LoadingBar.module.css";
import * as React from "react";

interface LoadingBarProps {
    enabled: boolean
    error: boolean
}

const LoadingBar = ({enabled, error}: LoadingBarProps) => {
    const rectangleClassName = `${styles.rectangle} ${enabled ? styles.enabled : styles.disabled}`
    const insideDiv = error
        ? <div className={styles.error}></div>
        : <div className={rectangleClassName}></div>;

    return (
        <div className={styles.bar}>
            {insideDiv}
        </div>
    )
};

export default LoadingBar;